export const getProgress = (expected: number | null, actual: number | null) => {
  if (!expected || !actual) return 0;

  return (actual / expected) * 100;
};
